import { createContext } from "react";

import { ICommandStore } from "@formant/core/model/data/ICommandStore";
import { IDeviceStore } from "@formant/core/model/data/IDeviceStore";
import { IEventStore } from "@formant/core/model/data/IEventStore";
import { IModuleStore } from "@formant/core/model/data/IModuleStore";
import { IQueryStore } from "@formant/core/model/data/IQueryStore";

import { IAdapterStore } from "../../store/IAdapterStore";
import { IAnnotationTemplateStore } from "../../store/IAnnotationTemplateStore";
import { IAppStore } from "../../store/IAppStore";
import { IAuthStore } from "../../store/IAuthStore";
import { IChannelStore } from "../../store/IChannelStore";
import { ICommandTemplateStore } from "../../store/ICommandTemplateStore";
import { IConnectedStore } from "../../store/IConnectedStore";
import { IDeviceConfigurationStore } from "../../store/IDeviceConfigurationStore";
import { IDeviceConfigurationTemplateStore } from "../../store/IDeviceConfigurationTemplateStore";
import { IDeviceDetailsStore } from "../../store/IDeviceDetailsStore";
import { IGroupStore } from "../../store/IGroupStore";
import { IMetadataStore } from "../../store/IMetadataStore";
import { IObserveStore } from "../../store/IObserveStore";
import { IOnDemandStore } from "../../store/IOnDemandStore";
import { IOnlineDevicesStore } from "../../store/IOnlineDevicesStore";
import { IOperateStore } from "../../store/IOperateStore";
import { IOrganizationStore } from "../../store/IOrganizationStore";
import { IRoleStore } from "../../store/IRoleStore";
import { IRouterStore } from "../../store/IRouterStore";
import { IRtcSignalingStore } from "../../store/IRtcSignalingStore";
import { ISignalingStore } from "../../store/ISignalingStore";
import { ISsoStore } from "../../store/ISsoStore";
import { IStreamCurrentValueStore } from "../../store/IStreamCurrentValueStore";
import { IStreamStore } from "../../store/IStreamStore";
import { ITagTemplateStore } from "../../store/ITagTemplateStore";
import { ITeamStore } from "../../store/ITeamStore";
import { IUsageMetricsStore } from "../../store/IUsageMetricsStore";
import { IUserStore } from "../../store/IUserStore";
import { IViewStore } from "../../store/IViewStore";
import { fakeStoreImplementation } from "./fakeStoreImplementation";

export interface IStores {
    adapterStore: IAdapterStore;
    annotationTemplateStore: IAnnotationTemplateStore;
    appStore: IAppStore;
    authStore: IAuthStore;
    channelStore: IChannelStore;
    commandStore: ICommandStore;
    commandTemplateStore: ICommandTemplateStore;
    connectedStore: IConnectedStore;
    customModuleStore: IModuleStore;
    deviceConfigurationStore: IDeviceConfigurationStore;
    deviceConfigurationTemplateStore: IDeviceConfigurationTemplateStore;
    deviceDetailsStore: IDeviceDetailsStore;
    deviceStore: IDeviceStore;
    eventStore: IEventStore;
    groupStore: IGroupStore;
    metadataStore: IMetadataStore;
    observeStore: IObserveStore;
    onDemandStore: IOnDemandStore;
    onlineDevicesStore: IOnlineDevicesStore;
    operateStore: IOperateStore;
    organizationStore: IOrganizationStore;
    queryStore: IQueryStore;
    roleStore: IRoleStore;
    routerStore: IRouterStore;
    rtcSignalingStore: IRtcSignalingStore;
    signalingStore: ISignalingStore;
    ssoStore: ISsoStore;
    streamCurrentValueStore: IStreamCurrentValueStore;
    streamStore: IStreamStore;
    tagTemplateStore: ITagTemplateStore;
    teamStore: ITeamStore;
    usageMetricsStore: IUsageMetricsStore;
    userStore: IUserStore;
    viewStore: IViewStore;
}

export const defaultFakeStores: IStores = {
    adapterStore: fakeStoreImplementation("adapterStore"),
    annotationTemplateStore: fakeStoreImplementation("annotationTemplateStore"),
    appStore: fakeStoreImplementation("appStore"),
    authStore: fakeStoreImplementation("authStore"),
    channelStore: fakeStoreImplementation("channelStore"),
    commandStore: fakeStoreImplementation("commandStore"),
    commandTemplateStore: fakeStoreImplementation("commandTemplateStore"),
    connectedStore: fakeStoreImplementation("connectedStore"),
    customModuleStore: fakeStoreImplementation("customModuleStore"),
    deviceConfigurationStore: fakeStoreImplementation(
        "deviceConfigurationStore",
    ),
    deviceConfigurationTemplateStore: fakeStoreImplementation(
        "deviceConfigurationTemplateStore",
    ),
    deviceDetailsStore: fakeStoreImplementation("deviceDetailsStore"),
    deviceStore: fakeStoreImplementation("deviceStore"),
    eventStore: fakeStoreImplementation("eventStore"),
    groupStore: fakeStoreImplementation("groupStore"),
    metadataStore: fakeStoreImplementation("metadataStore"),
    observeStore: fakeStoreImplementation("observeStore"),
    onDemandStore: fakeStoreImplementation("onDemandStore"),
    onlineDevicesStore: fakeStoreImplementation("onlineDevicesStore"),
    operateStore: fakeStoreImplementation("operateStore"),
    organizationStore: fakeStoreImplementation("organizationStore"),
    queryStore: fakeStoreImplementation("operateStore"),
    roleStore: fakeStoreImplementation("roleStore"),
    routerStore: fakeStoreImplementation("roleStore"),
    rtcSignalingStore: fakeStoreImplementation("rtcSignalingStore"),
    signalingStore: fakeStoreImplementation("signalingStore"),
    ssoStore: fakeStoreImplementation("ssoStore"),
    streamCurrentValueStore: fakeStoreImplementation("streamCurrentValueStore"),
    streamStore: fakeStoreImplementation("streamStore"),
    tagTemplateStore: fakeStoreImplementation("tagTemplateStore"),
    teamStore: fakeStoreImplementation("teamStore"),
    userStore: fakeStoreImplementation("userStore"),
    usageMetricsStore: fakeStoreImplementation("usageMetricsStore"),
    viewStore: fakeStoreImplementation("viewStore"),
};

export const StoreContext = createContext<IStores>(defaultFakeStores);
